import {
  SHOW_SEARCH_BAR_IN_HEADER
} from '../constants/AppConstants';

const initialState = {
  showSearchBarInHeader: false,
};

export default (state = initialState, action) => {

  switch (action.type) {
    case SHOW_SEARCH_BAR_IN_HEADER: {
      return {
        ...state,
        showSearchBarInHeader: action.showSearchBarInHeader
      }
    }

    default: {
      return state;
    }
  }
};
